'use client';

import { incrementTelemetry } from 'core-events/actions';
import { startTransition, useEffect } from 'react';

import { detectBot } from '../lib/botDetection';

export function UtmCookieSetup(): null {
    useEffect(() => {
        startTransition(() => {
            void detectBot().then((result) => {
                const payload = {
                    url: window.location.href,
                    isBot: result.bot,
                };

                void fetch('/api/visitor-setup', {
                    method: 'POST',
                    body: JSON.stringify(payload),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (result.bot) {
                    void incrementTelemetry('visitor.botVisitorIdDenied');
                }
            });
        });
    }, []);
    return null;
}
